import { gql } from '@apollo/client';

export interface IsAreaWithoutRecentAlgoSplitResponse {
    isAreaWithoutRecentAlgoSplit: boolean;
}

export interface IsAreaWithoutRecentAlgoSplitVariables {
    warehouseId: number;
    areaId: number;
    taskDate: string;
}

/**
 * 算法分单引导：判断区域是否「连续 3 天未使用算法分单」。
 * 判定窗口 [taskDate-3, taskDate-1]（不含当天），逻辑在 schedule 侧。
 * 返回 true 表示连续 3 天未使用算法分单，可用于引导切换。
 */
export const IS_AREA_WITHOUT_RECENT_ALGO_SPLIT = gql`
    query IsAreaWithoutRecentAlgoSplit(
        $warehouseId: Long!
        $areaId: Long!
        $taskDate: LocalDate!
    ) {
        isAreaWithoutRecentAlgoSplit(
            warehouseId: $warehouseId
            areaId: $areaId
            taskDate: $taskDate
        )
    }
`;
